import { SaleSheetUpload } from '../../pages';

import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { PayrollController } from '../../controllers';

const SaleSheetUploadContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const uploadClick = async payload => {
		setUploaded(true);
	};
	const onSubmit = async () => {
		const formData = new FormData();
		setLoading(true);
		let fileToSend;

		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		if (!fileToSend) {
			setLoading(false);
			return MimaToastUtil.error({
				message: 'Kindly select a file',
			});
		}
		formData.append('sales', fileToSend);
		const { status, errorMessage } =
			await PayrollController.uploadSalesSheet(formData);
		if (status === constant.Success) {
			setUploaded(true);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);

	};

	return (
		<SaleSheetUpload
			closeModal={closeModal}
			uploaded={uploaded}
			onSubmit={onSubmit}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default SaleSheetUploadContainer;
